import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ConfigService } from '../../../services/config.service';
declare var $: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'edit-form-fields',
    templateUrl: './edit-form-fields.component.html',
    styleUrls: ['./edit-form-fields.component.css']
})
export class EditFormFieldsComponent implements OnChanges {

    @Input()
    fieldConfig: any = {};

    @Input()
    config: any[] = [];
    formFields = [];

    EditForm: FormGroup;

    options = [];

    termsNote = 'You can also add a link to an external page in the label field using the HTML anchor tag. \n' +
        'Ex: Agree <a href="http://www.recruiteze.com" target="_blank">Terms & Conditions</a>';

    @Output()
    saveChangesToFormField: EventEmitter<any> = new EventEmitter<any>();

    constructor(private fb: FormBuilder, private configService: ConfigService) {
    }

    get displayName() {
        let field = this.configService.formFieldsToAdd.find(field => {
            return field.value === (this.fieldConfig.input_type || this.fieldConfig.type)
        });
        return field ? field.name : '';
    }

    ngOnChanges() {
        if (this.fieldConfig.type === 'select' || this.fieldConfig.type === 'radio') {
            this.options = this.fieldConfig.options;
        }

        this.fieldConfig['displayName'] = this.displayName;

        if (this.fieldConfig.type === 'checkbox') {
            this.options = this.fieldConfig.choices;
        }

        this.EditForm = this.fb.group({
            fieldLabel: [this.fieldConfig.label],
            convertToTag: [this.fieldConfig.convertToTag],
            eeo: [this.fieldConfig.eeo],
            fieldPlaceholder: [this.fieldConfig.placeholder],
            fieldIdentifier: [this.fieldConfig.name, Validators.required],
            fieldOptions: this.fb.array(this.options),
            fieldRequired: [this.fieldConfig.validatorInfo.required]
        });
    }

    get optionsForm() {
        return this.EditForm.get('fieldOptions') as FormArray;
    }

    addOption() {
        this.optionsForm.push(this.fb.control(''));
    }

    deleteOption(i) {
        this.optionsForm.removeAt(i);
    }

    validateField(fieldID) {
        const f = this.EditForm.controls;
        if (f[fieldID].invalid && (f[fieldID].dirty || f[fieldID].touched)) {
            if (f[fieldID].errors.required) {
                $('#' + fieldID).addClass('invalid-error');
                return true;
            }
        } else {
            $('#' + fieldID).removeClass('invalid-error');
            return false;
        }
    }

    shouldShowPlaceHolder(fieldType: string): boolean {
        return fieldType !== 'terms' && fieldType !== 'infoMessage';
    }

    getMaxLabelLength(): Number {
        return this.fieldConfig.labelMaxCharacters || 255;
    }

    getMaxLabelRows(): Number {
        return this.fieldConfig.labelMaxRows || 3;
    }

}
